<template>
  <div class="row justify-content-center mt-5">
    <div class="col-12">
      <div
        class="card bg-secondary shadow border-0 vld-parent"
        ref="formContainer"
      >
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-left mb-4">
            <h1>POLÍTICA DE PRIVACIDADE</h1>
            <p>
              Este site é mantido e operado por STARS INVESTIMENTOS EM NOVOS
              NEGOCIOS LTDA.
            </p>
            <p>
              Nós coletamos e utilizamos alguns dados pessoais que pertencem
              àqueles que utilizam nosso site. Ao fazê-lo, agimos na qualidade
              de controlador desses dados e estamos sujeitos às disposições da
              Lei Federal n. 13.709/2018 (Lei Geral de Proteção de Dados
              Pessoais - LGPD).
            </p>
            <p>
              Nós cuidamos da proteção de seus dados pessoais e, por isso,
              disponibilizamos esta política de privacidade, que contém
              informações importantes sobre:
            </p>
            <ul>
              <li>Quem deve utilizar nosso site;</li>
              <li>Quais dados coletamos e o que fazemos com eles;</li>
              <li>Seus direitos em relação aos seus dados pessoais;</li>
              <li>Como entrar em contato conosco.</li>
            </ul>
            <hr />
            <ol class="m-0 p-3">
              <li class="list-bold"><h2>Quem deve utilizar nosso site</h2></li>
              <p>
                Nosso site só deve ser utilizado por pessoas com mais de dezoito
                anos de idade. Sendo assim, crianças e adolescentes não devem
                utilizá-lo.
              </p>

              <hr />

              <li class="list-bold">
                <h2>Dados que coletamos e motivos da coleta</h2>
              </li>
              <p>
                Nosso site coleta e utiliza alguns dados pessoais de nossos
                usuários, de acordo com o disposto nesta seção.
              </p>
              <ol>
                <li>
                  Dados pessoais fornecidos expressamente pelo usuário Nós
                  coletamos os seguintes dados pessoais que nossos usuários nos
                  fornecem expressamente ao utilizar nosso site:
                </li>
                <ul>
                  <li>Nome Completo</li>
                  <li>CPF</li>
                  <li>Data de Aniversário</li>
                  <li>Cidade em que reside</li>
                  <li>Estado em que reside</li>
                  <li>Número de celular</li>
                  <li>Ocupação</li>
                  <li>Empresa em que trabalha</li>
                  <li>Telefone Comercial</li>
                  <li>Email</li>
                  <li>Instagram</li>
                  <li>Linkedin</li>
                </ul>
                <p>A coleta destes dados ocorre nos seguintes momentos:</p>
                <ul>
                  <li>Quando o usuário se cadastra no site</li>
                  <li>
                    Quando o usuário decide participar de eventos do aplicativo
                  </li>
                </ul>
                <p>
                  Os dados fornecidos por nossos usuários são coletados com as
                  seguintes finalidades:
                </p>
                <ul>
                  <li>Para que o usuário possa se cadastrar no site</li>
                  <li>
                    Para que o usuário possa participar de eventos do aplicativo
                  </li>
                </ul>
                <li class="mt-3">Dados pessoais obtidos de outras formas</li>
                <p>
                  Nós coletamos os seguintes dados pessoais de nossos usuários:
                </p>
                <ul>
                  <li>Endereço de IP</li>
                  <li>Informações de geolocalização</li>
                  <li>Informações de navegação no site</li>
                  <li>Dados retenção em cada tela do aplicativo</li>
                </ul>
                <p>A coleta destes dados ocorre nos seguintes momentos:</p>
                <ul>
                  <li>Quando o usuário acessa o site</li>
                  <li>Quando faz login ou logout do site</li>
                  <li>
                    Quando o usuário fica navegando entre as telas do aplicativo
                  </li>
                  <li>
                    Quando o usuário faz alguma ação de clique dentro do
                    aplicativo
                  </li>
                </ul>
                <p>Estes dados são coletados com as seguintes finalidades:</p>
                <ul>
                  <li>
                    Para garantir segurança e autenticidade das ações feitas
                    dentro do site
                  </li>
                  <li>
                    Para fornecer dados de usabilidade para melhorar a
                    experiência do usuário
                  </li>
                </ul>
                <li class="mt-3">Dados sensíveis</li>
                <p>
                  <strong>Não</strong> serão coletados dados sensíveis de nossos
                  usuários, assim entendidos aqueles definidos nos arts. 11 e
                  seguintes da Lei de Proteção de Dados Pessoais. Assim,
                  <strong>não</strong> haverá coleta de dados sobre origem
                  racial ou étnica, convicção religiosa, opinião política,
                  filiação a sindicato ou a organização de caráter religioso,
                  filosófico ou político, dado referente à saúde ou à vida
                  sexual, dado genético ou biométrico, quando vinculado a uma
                  pessoa natural.
                </p>
                <li>Cookies</li>
                <p>
                  Cookies são pequenos arquivos de texto baixados
                  automaticamente em seu dispositivo quando você acessa e navega
                  por um site. Eles servem, basicamente, para seja possível
                  identificar dispositivos, atividades e preferências de
                  usuários.
                </p>
                <p>
                  Os cookies não permitem que qualquer arquivo ou informação
                  sejam extraídos do disco rígido do usuário, não sendo
                  possível, ainda, que, por meio deles, se tenha acesso a
                  informações pessoais que não tenham partido do usuário ou da
                  forma como utiliza os recursos do site.
                </p>
                <ol type="a">
                  <li>Cookies de terceiros</li>
                  <p>
                    Alguns de nossos parceiros podem configurar cookies nos
                    dispositivos dos usuários que acessam nosso site.
                  </p>
                  <p>
                    Estes cookies, em geral, visam possibilitar que nossos
                    parceiros possam oferecer seu conteúdo e seus serviços ao
                    usuário que acessa nosso site de forma personalizada, por
                    meio da obtenção de dados de navegação extraídos a partir de
                    sua interação com o site.
                  </p>
                  <p>
                    O usuário poderá obter mais informações sobre os cookies de
                    terceiro e sobre a forma como os dados obtidos a partir dele
                    são tratados, além de ter acesso à descrição dos cookies
                    utilizados e de suas características, acessando o seguinte
                    link:
                  </p>
                  <p class="p-3">
                    Ex: Google Analytics <br />
                    <a href="https://policies.google.com/technologies/cookies"
                      >https://policies.google.com/technologies/cookies</a
                    >
                  </p>
                  <p>
                    As entidades encarregadas da coleta dos cookies poderão
                    ceder as informações obtidas a terceiros.
                  </p>
                  <li>Gestão de Cookies</li>
                  <p>
                    O usuário poderá se opor ao registro de cookies pelo site,
                    bastando que desative esta opção no seu próprio navegador.
                    Mais informações sobre como fazer isso em alguns dos
                    principais navegadores utilizados hoje podem ser acessadas a
                    partir dos seguintes links:
                  </p>
                  <p class="p-3">
                    Internet Explorer:<br />
                    <a
                      href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
                      >https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies</a
                    ><br />
                    Safari:<br />
                    <a
                      href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
                      >https://support.apple.com/pt-br/guide/safari/sfri11471/mac</a
                    ><br />
                    Google Chrome:<br />
                    <a
                      href="https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt"
                      >https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt</a
                    >
                    <br />
                    Mozila Firefox:<br />
                    <a
                      href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam"
                      >https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam</a
                    ><br />
                    Opera:<br />
                    <a
                      href="https://www.opera.com/help/tutorials/security/privacy/"
                      >https://www.opera.com/help/tutorials/security/privacy/</a
                    >
                  </p>
                  <p>
                    A desativação dos cookies, no entanto, pode afetar a
                    disponibilidade de algumas ferramentas e funcionalidades do
                    site, comprometendo seu correto e esperado funcionamento.
                    Outra consequência possível é remoção das preferências do
                    usuário que eventualmente tiverem sido salvas, prejudicando
                    sua experiência.
                  </p>
                </ol>
                <li>Coleta de dados não previstos expressamente</li>
                <p>
                  Eventualmente, outros tipos de dados não previstos
                  expressamente nesta Política de Privacidade poderão ser
                  coletados, desde que sejam fornecidos com o consentimento do
                  usuário, ou, ainda, que a coleta seja permitida com fundamento
                  em outra base legal prevista em lei.
                </p>
                <p>
                  Em qualquer caso, a coleta de dados e as atividades de
                  tratamento dela decorrentes serão informadas aos usuários do
                  site.
                </p>
              </ol>
              <li>Compartilhamento de dados pessoais com terceiros</li>
              <p>
                Nós não compartilhamos seus dados pessoais com terceiros. Apesar
                disso, é possível que o façamos para cumprir alguma determinação
                legal ou regulatória, ou, ainda, para cumprir alguma ordem
                expedida por autoridade pública.
              </p>
              <li>Por quanto tempo seus dados pessoais serão armazenados</li>
              <p>
                Os dados pessoais coletados pelo site são armazenados e
                utilizados por período de tempo que corresponda ao necessário
                para atingir as finalidades elencadas neste documento e que
                considere os direitos de seus titulares, os direitos do
                controlador do site e as disposições legais ou regulatórias
                aplicáveis.
              </p>
              <p>
                Uma vez expirados os períodos de armazenamento dos dados
                pessoais, eles são removidos de nossas bases de dados ou
                anonimizados, salvo nos casos em que houver a possibilidade ou a
                necessidade de armazenamento em virtude de disposição legal ou
                regulatória.
              </p>
              <li>Bases legais para o tratamento de dados pessoais</li>
              <p>
                Cada operação de tratamento de dados pessoais precisa ter um
                fundamento jurídico, ou seja, uma base legal, que nada mais é
                que uma justificativa que a autorize, prevista na Lei Geral de
                Proteção de Dados Pessoais.
              </p>
              <p>
                Todas as Nossas atividades de tratamento de dados pessoais
                possuem uma base legal que as fundamenta, dentre as permitidas
                pela legislação. Mais informações sobre as bases legais que
                utilizamos para operações de tratamento de dados pessoais
                específicas podem ser obtidas a partir de nossos canais de
                contato, informados ao final desta Política.
              </p>
              <li>Como o titular pode exercer seus direitos</li>
              <p>
                Para garantir que o usuário que pretende exercer seus direitos
                é, de fato, o titular dos dados pessoais objeto da requisição,
                poderemos solicitar documentos ou outras informações que possam
                auxiliar em sua correta identificação, a fim de resguardar
                nossos direitos e os direitos de terceiros. Isto somente será
                feito, porém, se for absolutamente necessário, e o requerente
                receberá todas as informações relacionadas.
              </p>
              <li>Medidas de segurança no tratamento de dados pessoais</li>
              <p>
                Empregamos medidas técnicas e organizativas aptas a proteger os
                dados pessoais de acessos não autorizados e de situações de
                destruição, perda, extravio ou alteração desses dados.
              </p>
              <p>
                As medidas que utilizamos levam em consideração a natureza dos
                dados, o contexto e a finalidade do tratamento, os riscos que
                uma eventual violação geraria para os direitos e liberdades do
                usuário, e os padrões atualmente empregados no mercado por
                empresas semelhantes à nossa.
              </p>
              <p>
                Entre as medidas de segurança adotadas por nós, destacamos as
                seguintes:
              </p>
              <ul>
                <li>Restrições de acesso a dados pessoais</li>
                <li>Monitoramento de acessos a dados pessoais</li>
                <li>Proteção de dados pessoais por meio de criptografia</li>
                <li>Utilização de medidas de proteção digital</li>
                <li>
                  Elaboração e implementação de políticas internas de segurança
                  da informação
                </li>
              </ul>
              <p>
                Ainda que adote tudo o que está ao seu alcance para evitar
                incidentes de segurança, é possível que ocorra algum problema
                motivado exclusivamente por um terceiro como em caso de ataques
                de hackers ou crackers ou, ainda, em caso de culpa exclusiva do
                usuário, que ocorre, por exemplo, quando ele mesmo transfere
                seus dados a terceiro. Assim, embora sejamos, em geral,
                responsáveis pelos dados pessoais que tratamos, nos eximimos de
                responsabilidade caso ocorra uma situação excepcional como
                essas, sobre as quais não temos nenhum tipo de controle.
              </p>
              <p>
                De qualquer forma, caso ocorra qualquer tipo de incidente de
                segurança que possa gerar risco ou dano relevante para qualquer
                de nossos usuários, comunicaremos os afetados e a Autoridade
                Nacional de Proteção de Dados acerca do ocorrido, em
                conformidade com o disposto na Lei Geral de Proteção de Dados.
              </p>
              <li>Alterações nesta política</li>
              <p>
                A presente versão desta Política de Privacidade foi atualizada
                pela última vez em: 02/04/2024.
              </p>
              <p>
                Reservamo-nos o direito de modificar, a qualquer momento, as
                presentes normas, especialmente para adaptá- las às eventuais
                alterações feitas em nosso site, seja pela disponibilização de
                novas funcionalidades, seja pela supressão ou modificação
                daquelas já existentes.
              </p>
              <p>
                Sempre que houver uma modificação, nossos usuários serão
                notificados acerca da mudança.
              </p>
              <li>Como entrar em contato conosco</li>
              <p>
                Para esclarecer quaisquer dúvidas sobre esta Política de
                Privacidade ou sobre os dados pessoais que tratamos, entre em
                contato com nosso Encarregado de Proteção de Dados Pessoais, por
                algum dos canais mencionados abaixo:
              </p>
              <p><strong>E-mail:</strong> tistarsaceleradora@gmail.com</p>
              <p>
                <strong>Endereço postal:</strong> Av. Rio Branco, 639-Centro,
                Santa Maria - RS, 97010-421, sala 400
              </p>
            </ol>
          </div>

          <div class="text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "politica-de-privacidade",
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.list-bold {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
}
ol > li {
  font-weight: bold;
}
ul + p,
li + p {
  margin-top: 1rem;
}
</style>
